import { Cross2Icon } from '@radix-ui/react-icons';
import { FlexProps, Box, Flex, IconButton, Text } from '@radix-ui/themes';
import { useState } from 'react';

import styles from './SlidingPanel.module.css';

export type SlidingPanelProps = FlexProps & {
    open: boolean;
    onClose: () => void;
    title: string;
    subtitle?: string;
};

export const SlidingPanel = ({
    open,
    onClose,
    title,
    subtitle,
    width = { initial: '100%', sm: '600px' },
    children,
    className,
    onAnimationEnd,
    ...flexProps
}: SlidingPanelProps) => {
    const [shouldRender, setShouldRender] = useState(false);

    if (open && !shouldRender) {
        setShouldRender(true);
    }

    if (!shouldRender) return null;

    return (
        <Box
            className={`${styles.wrapper} ${open ? styles.wrapperOpen : styles.wrapperClosed}`}
        >
            <Box
                className={`${styles.overlay} ${open ? styles.overlayOpen : styles.overlayClosed}`}
                onClick={onClose}
            />

            <Flex
                direction='column'
                width={width}
                {...flexProps}
                className={`${styles.panel} ${open ? styles.panelOpen : styles.panelClosed} ${className || ''}`.trim()}
                onAnimationEnd={(e) => {
                    if (e.target === e.currentTarget && !open) {
                        setShouldRender(false);
                    }
                    onAnimationEnd?.(e);
                }}
            >
                <Flex
                    px='5'
                    py='4'
                    justify='between'
                    align='center'
                    style={{ borderBottom: '1px solid var(--gray-a4)' }}
                >
                    <Box>
                        <Text as='div' size='4' weight='bold'>
                            {title}
                        </Text>
                        {subtitle && (
                            <Text as='div' size='2' color='gray'>
                                {subtitle}
                            </Text>
                        )}
                    </Box>
                    <IconButton variant='ghost' color='gray' onClick={onClose}>
                        <Cross2Icon width='20' height='20' />
                    </IconButton>
                </Flex>

                {children}
            </Flex>
        </Box>
    );
};
